import React from 'react';
import { TMUA_PEARSON_TOKENS } from '../constants/tmuaPearsonTokens';

const T = TMUA_PEARSON_TOKENS;

const cell = {
  border: `1px solid ${T.instructionTableBorder}`,
  padding: '3px 14px',
  background: '#FFFFFF',
  color: '#000000',
  fontWeight: 400,
  fontSize: 16,
  lineHeight: 1.25,
};

const headCell = { ...cell, fontWeight: 700 };

export function TmuaPearsonInstructionTable({ rows }) {
  return (
    <table style={{ borderCollapse: 'collapse', margin: '0 0 18px', fontSize: 13, color: '#000' }}>
      <thead>
        <tr>
          <th style={{ ...headCell, textAlign: 'left' }}>Section</th>
          <th style={{ ...headCell, textAlign: 'center', maxWidth: 120 }}>
            Number of
            <br />
            Questions
          </th>
          <th style={{ ...headCell, textAlign: 'center' }}>Time</th>
        </tr>
      </thead>
      <tbody>
        {(rows || []).map((row) => (
          <tr key={row.section}>
            <td style={{ ...cell, textAlign: 'left' }}>{row.section}</td>
            <td style={{ ...cell, textAlign: 'center' }}>{row.questions}</td>
            <td style={{ ...cell, textAlign: 'center' }}>{row.time}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}

export function TmuaPearsonInstructionPage({ children }) {
  return (
    <div
      style={{
        position: 'absolute',
        inset: 0,
        overflowY: 'auto',
        padding: '18px 22px',
        color: T.instructionBody,
        fontFamily: 'Tahoma, Arial, Helvetica, sans-serif',
        fontSize: 16,
        lineHeight: 1.45,
      }}
    >
      {children}
    </div>
  );
}

export function NextNCopy() {
  return (
    <p style={{ margin: 0, color: '#000' }}>
      Please click the <strong>Next (N)</strong> button to proceed.
    </p>
  );
}
